import { render, staticRenderFns } from "./DictDeleteList.vue?vue&type=template&id=9e32caa0&scoped=true&"
import script from "./DictDeleteList.vue?vue&type=script&lang=js&"
export * from "./DictDeleteList.vue?vue&type=script&lang=js&"
import style0 from "./DictDeleteList.vue?vue&type=style&index=0&id=9e32caa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e32caa0",
  null
  
)

export default component.exports